

































































import { Component } from 'vue-property-decorator';
import { ProductListModule } from '@/store/Products/ProductListModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ListUtils from '@/lib/listUtils';
import ProductType from '@/models/Products/ProductType';
import ProductSubType from '@/models/Products/ProductSubType';
import ProductState from '@/models/Products/ProductState';

@Component({ name: 'ProductFilterDialog' })
export default class extends SaascadaVueDialog {

    dialog = false;
    filterByProductType: ProductType = null;
    filterByProductSubType: ProductSubType = null;
    filterByProductState: ProductState = null;

    get stateOptions() {
        return ListUtils.productStateOptions();
    }

    get typeOptions() {
        return ListUtils.productTypeOptions();
    }

    get subTypeOptions() {
        if (this.filterByProductType === ProductType.Lending) {
            return ListUtils.lendingProductSubTypeOptions();
        }
        else {
            return ListUtils.depositProductSubTypeOptions();
        }
    }

    async clear() {
        // Clear local filters and product module filters
        this.filterByProductType = null;
        this.filterByProductSubType = null;
        this.filterByProductState = null;
        ProductListModule.clearAllFilters();
        // Close dialog first then get products again
        this.dialog = false;
        await ProductListModule.getProducts(1);
    }

    async cancel() {
        // Reset local filters back to matching the value of the module filters
        this.filterByProductType = ProductListModule.filterByProductType;
        this.filterByProductSubType = ProductListModule.filterByProductSubType;
        this.filterByProductState = ProductListModule.filterByProductState;
        this.dialog = false;
    }

    async save() {
        // Update the filters in the product module
        ProductListModule.updateProductTypeFilter(this.filterByProductType);
        ProductListModule.updateProductSubTypeFilter(this.filterByProductSubType);
        ProductListModule.updateProductStateFilter(this.filterByProductState);
        // Close dialog first then get products again
        this.dialog = false;
        await ProductListModule.getProducts(1);
    }

}
